export default __webpack_public_path__ + "static/media/z_wdt_c_4.753a5a5b.mp3";